import { useContent } from '@/content'
import { Section } from '@/components/ui'
import { Logo } from '../Logo'
import styles from './Footer.module.css'

/** Centred wordmark and credit line. */
export const Footer = () => {
  const { site } = useContent()

  return (
  <Section as="footer" spacious wide innerClassName={styles.inner}>
    <Logo size={32} />
    <p className={`t-12 ${styles.credit}`}>
      &copy;{site.copyrightYear} {site.owner}. All rights reserved.
    </p>
  </Section>
  )
}
